import {userOperateLogList} from 'api/userOperateLog';
import Cookies from 'js-cookie';

const userOperateLog = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        userOperateLogList({commit},params) {
            return new Promise((resolve, reject) => {
                var startTime = params.startTime;
                var endTime = params.endTime;
                var userName = params.userName;
                var moduleName = params.moduleName;
                var type = params.type;
                var param = params.param;
                var psize = params.psize;
                var currentPage = params.currentPage;
                userOperateLogList(startTime,endTime,userName,moduleName,type,param,psize,currentPage).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        }
    }
};

export default userOperateLog;



// WEBPACK FOOTER //
// ./src/store/modules/userOperateLog.js